module.exports = __webpack_public_path__ + "media/npc_dota_hero_luna.85f14525.webm";